import { doc, getDoc, runTransaction, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase-config.js";

export async function createUserProfile(user, additionalData = {}) {
  if (!user?.uid) return null;

  const userRef = doc(db, "users", user.uid);

  const existingSnapshot = await getDoc(userRef);

  if (existingSnapshot.exists()) return userRef;

  await runTransaction(db, async (transaction) => {
    const snapshot = await transaction.get(userRef);

    if (snapshot.exists()) return;

    const email = user.email || "";

    transaction.set(userRef, {
      displayName: user.displayName || email.split("@")[0] || "Utilisateur",
      email,
      createdAt: serverTimestamp(),
      isPremium: false,
      trialUsed: false,
      uiPreferences: { backgrounds: { lightIndex: 0, darkIndex: 0 }, playerListeningMode: "music", theme: "light" },
      ...additionalData,
    });
  });

  return userRef;
}